import { Briefcase } from 'lucide-react';

export default function FeaturedHeader({ title, subtitle, isAr }) {
  return (
    <div className="featured-section-header">
      <Briefcase
        size={28}
        strokeWidth={2}
        className="featured-header-icon"
      />
      <div className="featured-header-content">
        <h2 className="featured-title">{title}</h2>
        <p className="featured-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}
